// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__SW0hx","menu":"Navbar_menu__N30DZ","mobile_btn":"Navbar_mobile_btn__TVTEF","active":"Navbar_active__09bEE","navbar2":"Navbar_navbar2__pS1Ap"};